import { ActionBar, Button } from '@hogwarts/ui-components-core';
import React, { useState } from 'react';

const InsightListItem = ({
  name,
  description,
  canView = true,
  onView,
  favourite,
  exportButtonProps,
  onFavourite,
  canDuplicate = true,
  onDuplicate,
  canDelete = true,
  onDelete,
  canExport = true,
  onExport,
  sharedWith,
}) => {
  const [isOver, setIsOver] = useState(false);

  // Handle export actions - use dropdown for multiple options
  let exportAction = null;
  if (exportButtonProps?.multipleExports && exportButtonProps.exportOptions) {
    // Create dropdown for multiple export options (e.g., profiles reports)
    exportAction = {
      text: 'Export',
      intent: 'primary',
      allowed: exportButtonProps.exportOptions.some(opt => opt.allowed),
      actions: exportButtonProps.exportOptions.map((option) => ({
        text: option.text,
        icon: option.icon,
        intent: option.intent,
        allowed: option.allowed,
        onClick: () => onExport(option.type),
      })),
    };
  } else if (onExport && exportButtonProps) {
    // Single export button for non-profiles reports
    exportAction = {
      ...exportButtonProps,
      onClick: () => onExport(), // Call without parameters for single export
    };
  }

  const actions = [
    onView && {
      text: 'View',
      icon: ['fal', 'table'],
      allowed: canView,
      onClick: onView,
    },
    exportAction,
    {
      icon: 'ellipsis-h',
      minimal: true,
      caret: false,
      actions: [
        canDuplicate && {
          text: 'Duplicate',
          allowed: canDuplicate,
          icon: ['fal', 'clone'],
          onClick: () => onDuplicate(),
        },
        {
          text: 'Delete',
          allowed: canDelete,
          icon: ['fal', 'trash'],
          intent: 'danger',
          onClick: () => onDelete(),
        },
      ],
    },
  ].filter(Boolean); // Filter out any undefined actions

  return (
    <div
      className="d-flex w-100 m-3 align-items-center"
      onMouseEnter={() => setIsOver(true)}
      onMouseLeave={() => {
        setIsOver(false);
      }}
    >
      <Button
        minimal
        className="mr-2"
        iconSize="lg"
        icon={favourite ? ['fa', 'star'] : ['far', 'star']}
        iconColor={favourite ? '#fecc00' : isOver ? 'gray' : 'lightgray'}
        onClick={() => onFavourite(!favourite)}
      />
      <div>
        <h5 className="m-0">{name}</h5>
        {description && <p className="text-muted mt-1 mb-1">{description}</p>}
        {sharedWith && (
          <p className="text-muted mt-1 mb-1">{`${sharedWith}`}</p>
        )}
      </div>
      <div className="flex-grow-1" style={{ width: '20px' }} />

      <ActionBar actions={actions} />
    </div>
  );
};

export default InsightListItem;
